/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// console.log(
// 	"Hello World! (from create-block-agenturschmucki-employee-archive block)",
// );
/* eslint-enable no-console */

document.addEventListener("DOMContentLoaded", function () {
	const filterButtons = document.querySelectorAll(".employee-filter-button");
	const employeeContainers = document.querySelectorAll(".employee-archive");
	let selectedFilters = [];

	const loadMoreButtons = document.querySelectorAll(
		".load-more-button-employee",
	);

	// Globale Flag, die anzeigt, ob gerade eine Anfrage läuft
	var isLoading = false;

	if (loadMoreButtons) {
		loadMoreButtons.forEach((button, index) => {
			let currentPage = parseInt(button.getAttribute("data-page")); // Die aktuelle Seite
			const maxPages = parseInt(button.getAttribute("data-max-page")); // Maximale Anzahl von Seiten
			const postsPerPage = parseInt(button.getAttribute("data-limit")); // Beiträge pro Seite

			// console.log("Initial Page: ", currentPage);
			// console.log("Max Pages: ", maxPages);
			// console.log("Posts per Page: ", postsPerPage);

			// Das entsprechende employee-archive-Element finden
			const employeeContainer = document.querySelector('.employee-archive[data-max-page="' + maxPages + '"]');
			if (!employeeContainer) {
				console.error("Employee container not found for button", index);
				return;
			}

			// Fallback: Wenn data-posts-per-page im Container vorhanden ist, verwende diesen Wert
			const containerPostsPerPage = employeeContainer.getAttribute('data-posts-per-page');
			const actualPostsPerPage = containerPostsPerPage ? parseInt(containerPostsPerPage) : postsPerPage;

			// console.log("Using posts per page: ", actualPostsPerPage);

			button.addEventListener("click", function () {
				// Wenn bereits eine Anfrage läuft, ignorieren wir den Klick
				if (isLoading) {
					// console.log("Lade-Vorgang läuft bereits, Klick ignoriert");
					return false;
				}

				if (currentPage >= maxPages) {
					button.style.display = "none";
					return;
				}

				// Flag setzen, dass ein Ladevorgang läuft
				isLoading = true;
				employeeContainer.classList.add('loading');
				// console.log("🔄 Loading animation started - added 'loading' class to:", employeeContainer);
				
				// Button visuell deaktivieren
				button.classList.add('disabled');
				button.style.pointerEvents = 'none';
				button.style.cursor = 'wait';
				// console.log("🔄 Button disabled");

				currentPage++; // Erhöhe die aktuelle Seite um 1

				// console.log("Loading Page: ", currentPage);

				const data = new FormData();
				data.append("action", "load_more_employee");
				data.append("paged", currentPage);
				data.append("posts_per_page", actualPostsPerPage);
				data.append("nonce", ajaxNonce || ""); // Sicherheits-Nonce

				fetch(ajaxurl, {
					method: "POST",
					body: data,
				})
					.then((response) => response.text())
					.then((html) => {
						// Ladevorgang abgeschlossen
						isLoading = false;
						employeeContainer.classList.remove('loading');
						// console.log("✅ Loading animation finished - removed 'loading' class from:", employeeContainer);
						
						// Button wieder aktivieren
						button.classList.remove('disabled');
						button.style.pointerEvents = '';
						button.style.cursor = '';
						// console.log("✅ Button re-enabled");

						// console.log("Received HTML:", html); // Debug
						employeeContainer.insertAdjacentHTML("beforeend", html);
						
						// Nach dem Laden: Neue Elemente für Filter verfügbar machen
						filterEmployee();
						
						if (currentPage >= maxPages) {
							// console.log("All pages loaded.");
							button.style.display = "none";
						}
					})
					.catch((error) => {
						// Auch bei Fehler Flag zurücksetzen und Button aktivieren
						isLoading = false;
						employeeContainer.classList.remove('loading');
						button.classList.remove('disabled');
						button.style.pointerEvents = '';
						button.style.cursor = '';
						console.error("❌ Loading error - reset loading state:", error);
					});
			});
		});
	}

	filterButtons.forEach((button) => {
		button.addEventListener("click", () => {
			const filter = button.dataset.filter;

			// Toggle active state
			button.classList.toggle("active");
			// Update selected filters
			if (selectedFilters.includes(filter)) {
				selectedFilters = selectedFilters.filter((f) => f !== filter);
			} else {
				selectedFilters.push(filter);
			}
			// console.log(selectedFilters);
			filterEmployee();
		});
	});

	function filterEmployee() {
		const employeeItems = document.querySelectorAll(".employee-card.archive");
		employeeItems.forEach((employeeItem) => {
			// Alle Kategorien/Spezialisierungen des Beitrags sammeln
			const categories = Array.from(
				employeeItem.querySelectorAll(".employee-categories li"),
			).map((li) => li.textContent);
			// console.log(categories);
			// Überprüfen, ob ALLE ausgewählten Filter in den Kategorien des Beitrags vorhanden sind
			const matchesFilter =
				selectedFilters.length === 0 ||
				selectedFilters.some((filter) => categories.includes(filter));

			employeeItem.addEventListener("transitionend", () => {
				if (employeeItem.classList.contains("hidden")) {
					employeeItem.style.display = "none";
				} 
			});
			// Beitrag anzeigen oder ausblenden basierend auf dem Filterergebnis
			// employeeItem.style.display = matchesFilter ? 'block' : 'none';
			if (matchesFilter) {
                if (employeeItem.style.display === "none") {
                    employeeItem.style.display = "block";
                    // Erzwinge einen Reflow, damit der Browser die Änderung verarbeitet.
                    void employeeItem.offsetWidth;
                }
				employeeItem.classList.remove("hidden");
			} else {
				employeeItem.classList.add("hidden");
			}
		});
	}
});
